module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flipper-buttons"
  }, [_c('button', {
    staticClass: "flipper-buttons__button",
    class: {
      'active': _vm.isActiveTab(1)
    },
    on: {
      "click": function($event) {
        return _vm.setTab(1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-year-planning"
  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.sub_scheduler.schedules_overview')) + "\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "flipper-buttons__button",
    class: {
      'active': _vm.isActiveTab(0)
    },
    on: {
      "click": function($event) {
        return _vm.setTab(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon-file-text"
  }), _vm._v("\n    " + _vm._s(_vm.$t('vue2.sub_scheduler.list')) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b6592c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppFlipperButtons.vue
// module id = 1630
// module chunks = 1